import React from 'react';
import ReusableTable from './ReusableTable';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { Link as MuiLink } from "@mui/material";
import { Link } from 'react-router-dom';

const renderBoxLink = (params: GridRenderCellParams) => {
  return (
    <MuiLink component={Link} to={`/device/${params.value}`} style={{ display: 'block', width: '100%', paddingLeft: '16px', fontSize: '1.2rem' }}>
      {params.value}
    </MuiLink>
  );
};

const renderContracts = (params: GridRenderCellParams) => {
  return params.value.join(', ');
};

const columns: GridColDef[] = [
  { field: 'box', headerName: 'Box', flex: 1, renderCell: renderBoxLink },
  { field: 'contracts', headerName: 'Contracts', flex: 1, renderCell: renderContracts },
];

interface ContractBoxesTableProps {
  search: string;
}

const ContractBoxesTable: React.FC<ContractBoxesTableProps> = ({ search }) => {
  return <ReusableTable fetchUrl="/view_dacapi_contract_boxes_unique" columns={columns} search={search} />;
};

export default ContractBoxesTable;
